export const JWT_STORAGE_KEY = 'jwt_access_token';
export const AMPLIFY_CONFIG_STORAGE_KEY = 'amplify_cognito_config';
